import { requireField } from './validators';

export default class IncidentParticipant {
  constructor(data = {}) {
    requireField(data.type, 'incident.participant.type');
    requireField(data.id, 'incident.participant.id');

    this.id = data.id;
    this.type = data.type; // 'student' | 'staff'
    this.name = data.name || '';
    this.role = data.role || '';
  }

  toJSON() {
    return { ...this };
  }
}
